module.exports = __webpack_public_path__ + "static/media/spin_audi.0b9c369c.png";